// extracted by mini-css-extract-plugin
export default {"dashboard":"HomeDashboard_dashboard__jfZno","kpiRow":"HomeDashboard_kpiRow__M9nky","kpiItem":"HomeDashboard_kpiItem__2pmw6"};